import { render, staticRenderFns } from "./BlockQuote.vue?vue&type=template&id=cd3c4bac&scoped=true"
import script from "./BlockQuote.vue?vue&type=script&lang=js"
export * from "./BlockQuote.vue?vue&type=script&lang=js"
import style0 from "./BlockQuote.vue?vue&type=style&index=0&id=cd3c4bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3c4bac",
  null
  
)

export default component.exports